/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockTenderEditCtrl
 */
angular.module('mercury.modules.stock.tender')
.controller('StockTenderEditCtrl', ["dialog", "ngToast", "$q", "$scope", "$state", "$stateParams", "StockBrands", "StockItems", "StockSuppliers", "StockTenders", "StockUnits", "title", function(dialog, ngToast, $q, $scope, $state, $stateParams, StockBrands, StockItems,
  StockSuppliers, StockTenders, StockUnits, title) {

  title.set('Edit Supplier Tender');

  $scope.items = StockItems.getAllActive();
  $scope.units = StockUnits.getAllActive();
  $scope.brands = StockBrands.getAllActive();
  $scope.suppliers = StockSuppliers.getAll();

  $scope.loading = $q.all([
    $scope.items.$promise,
    $scope.units.$promise,
    $scope.brands.$promise,
    $scope.suppliers.$promise
  ]);

  $scope.loading.then(function() {
    if ($stateParams.id) {
      $scope.loading = StockTenders.get($stateParams.id).$promise;
      $scope.loading.then(function(tender) {
        angular.forEach(tender.lines, function(line) {
          line.tempStockItemOrderingUnitId = line.stockItemOrderingUnitId;
          line.tempStockItemOrderingUnitName = line.stockItemOrderingUnitName;
          line.tempStockItemDefaultBrandId = line.stockItemDefaultBrandId;
          line.tempStockItemDefaultBrandName = line.stockItemDefaultBrandName;
        });

        $scope.tender = tender;
      });
    } else {
      $scope.tender = {
        lines: []
      };
    }
  });

  $scope.itemOptions = function() {
    var existingItems = {};
    angular.forEach($scope.tender.lines, function(line) {
      existingItems[line.stockItemId] = true;
    });

    var avaliableItems = [];
    angular.forEach($scope.items, function(item) {
      if (!existingItems[item.id]) {
        avaliableItems.push(item);
      }
    });
    return avaliableItems;
  };

  $scope.addTenderLine = function(item) {
    $scope.tender.lines.push({
      stockItemId: item.id,
      stockItemName: item.name,
      stockItemOrderingUnitId: item.orderingUnitId,
      stockItemOrderingUnitName: item.orderingUnitName,
      stockItemOrderingUnitRatio: item.orderingUnitRatio,
      stockItemDefaultBrandId: item.defaultBrandId,
      stockItemDefaultBrandName: item.defaultBrandName,
      // The temp fields bind to the inputs so we can revert any changes.
      tempStockItemOrderingUnitId: item.orderingUnitId,
      tempStockItemOrderingUnitName: item.orderingUnitName,
      tempStockItemDefaultBrandId: item.defaultBrandId,
      tempStockItemDefaultBrandName: item.defaultBrandName,
      unitCost: 0
    });
  };

  $scope.removeTenderLine = function(index) {
    $scope.tender.lines.splice(index, 1);
  };

  $scope.saveTender = function() {
    $scope.tenderEditForm.$setSubmitted();
    if ($scope.tenderEditForm.$invalid) {
      ngToast.dismiss();
      ngToast.danger('Please fix the errors on this tender.');
      return;
    }

    StockTenders.save($scope.tender)
    .then(function() {
      $state.go('Stock.TenderList');
    });
  };

  $scope.deleteTender = function() {
    StockTenders.remove($scope.tender)
    .then(function() {
      $state.go('Stock.TenderList');
    });
  };

  $scope.addItemGroupOptions = function() {
    var groups = {};
    angular.forEach($scope.itemOptions(), function(item) {
      groups[item.groupId] = {id: item.groupId, name: item.groupName};
    });

    var results = [];
    angular.forEach(groups, function(group) {
      results.push(group);
    });
    return results;
  };

  $scope.addItemGroup = function(group) {
    var existingItems = {};
    angular.forEach($scope.tender.lines, function(tenderLine) {
      existingItems[tenderLine.stockItemId] = true;
    });

    angular.forEach($scope.items, function(item) {
      if (item.groupId == group.id && !existingItems[item.id]) {
        $scope.addTenderLine(item);
      }
    });
  };

  $scope.changeItemUnit = function(line, newUnit) {
    dialog.confirm('This will update this items default ordering unit. Do you wish to continue?')
    .then(function(result) {
      if (result) {
        StockItems.patch(line.stockItemId, 'OrderingUnitId', line.tempStockItemOrderingUnitId)
        .then(function() {
          line.stockItemOrderingUnitId = line.tempStockItemOrderingUnitId;
          line.stockItemOrderingUnitName = line.tempStockItemOrderingUnitName;
          line.unitCost = (line.unitCost * line.stockItemOrderingUnitRatio) / newUnit.ratio;
          line.stockItemOrderingUnitRatio = newUnit.ratio;
        }, function() {
          line.tempStockItemOrderingUnitId = line.stockItemOrderingUnitId;
          line.tempStockItemOrderingUnitName = line.stockItemOrderingUnitName;
        });
      } else {
        line.tempStockItemOrderingUnitId = line.stockItemOrderingUnitId;
        line.tempStockItemOrderingUnitName = line.stockItemOrderingUnitName;
      }
    });
  };

  $scope.changeItemBrand = function(line) {
    dialog.confirm('This will update this items default brand. Do you wish to continue?')
    .then(function(result) {
      if (result) {
        StockItems.patch(line.stockItemId, 'DefaultBrandId', line.tempStockItemDefaultBrandId)
        .then(function() {
          line.stockItemDefaultBrandId = line.tempStockItemDefaultBrandId;
          line.stockItemDefaultBrandName = line.tempStockItemDefaultBrandName;
        }, function() {
          line.tempStockItemDefaultBrandId = line.stockItemDefaultBrandId;
          line.tempStockItemDefaultBrandName = line.stockItemDefaultBrandName;
        });
      } else {
        line.tempStockItemDefaultBrandId = line.stockItemDefaultBrandId;
        line.tempStockItemDefaultBrandName = line.stockItemDefaultBrandName;
      }
    });
  };
}]);
